import {WFS} from 'ol/format';
import {config} from '../config'
import { authenticationService } from '../services';
import {
	equalTo as equalToFilter,
	like as likeFilter,
	and as andFilter
  } from 'ol/format/filter';

export function exportToShapeFile(FileName, LayerNames){
	var featureRequest = new WFS().writeGetFeature({
		srsName: 'EPSG:3765',
		featureTypes: LayerNames,
		outputFormat: 'shape-zip',
		filter: equalToFilter('jls_id', `${authenticationService.currentUserValue.jls_id}`)
	});
	fetch(`${config.geoserverUrl}/ows`, {
		method: 'POST',
		body: new XMLSerializer().serializeToString(featureRequest)
	})
	.then(response => response.blob())
	.then(blob => {
		var url = window.URL.createObjectURL(blob);
		var a = document.createElement('a');
		a.href = url;
		a.download = FileName + ".zip";
		document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
		a.click();    
		a.remove();  //afterwards we remove the element again 	
	});
}